// @flow

import React from "react";
import { Field, useField } from "react-final-form";
import { Link } from "react-router-dom";
import type { FieldRenderProps } from "react-final-form";
import { changeServiceFormInteraction } from "Commons/Utilities/GoogleTagManager";
import AccountHolderAddressChanges from "modules/ChangeServiceForm/components/fields/Changes/AccountOwnerChanges";
import { read, readAndReplace } from "modules/ChangeServiceForm/misc/utilities";
import { RadioBasic, RadioGroupBasic } from "shared/formElements/Radio/RadioBasic";
import { ChangeServiceAuthorizationRoute } from "modules/ChangeService/ChangeServices/Routes";
import CompanyCheckbox from "./CompanyCheckbox";
import Contact from "./Contact/Contact";
import { Row, Error, Space } from "../shared/CommonComponents";
import { required } from "../../misc/validations";

type Props = {
  content: { infoTitle: string, paragraph: string, company: string, csAuthority: string },
  inheritedStyles: Object,
  stepName: string,
  categoryType: string,
  glossary: Object,
};

const AccountOwner = ({ content, inheritedStyles, stepName, categoryType, glossary }: Props) => {
  const {
    formRow,
    infoBoxAccountHolder,
    infoBoxAccountHolderTitle,
    infoBoxAccountHolderParagraph,
    errorMessage,
  } = inheritedStyles;

  const accountOwnerTypeField = useField("accountOwnerType");
  const propertyTypeField = useField("propertyType");
  const isCompany = propertyTypeField.input.value === "COMPANY";
  return (
    <>
      <Space rem={1} />
      <Row className={formRow}>
        <Field name="accountOwnerType" validate={required} type="radio">
          {(props: FieldRenderProps) => {
            return (
              <RadioGroupBasic centered inheritedStyles={inheritedStyles}>
                <RadioBasic
                  key={"csf_accOwner_1"}
                  label={"Ja"}
                  name="accountOwnerType"
                  value={"IMPORT_FROM_DELIVERY_ADDRESS"}
                  onChange={(value) => {
                    changeServiceFormInteraction(stepName, "CARDHOLDER_SAME");
                    return props.input.onChange(value);
                  }}
                  selected={true}
                  inheritedStyles={inheritedStyles}
                />
                <RadioBasic
                  key={"csf_accOwner_2"}
                  label={"Nein"}
                  name="accountOwnerType"
                  value={"DIFFERENT_ACCOUNT_OWNER"}
                  onChange={(value) => {
                    changeServiceFormInteraction(stepName, "CARDHOLDER_DIFF");
                    return props.input.onChange(value);
                  }}
                  selected={false}
                  inheritedStyles={inheritedStyles}
                />
              </RadioGroupBasic>
            );
          }}
        </Field>
        <Error name="accountOwnerType" className={errorMessage} />
      </Row>
      <Row className={formRow}>
        <div className={infoBoxAccountHolder}>
          <div className={infoBoxAccountHolderTitle}>{read(content.infoTitle)}</div>
          <p className={infoBoxAccountHolderParagraph}>
            {readAndReplace(content.paragraph, {
              replace: (domNode) => {
                if (domNode.attribs && domNode.attribs.id === "category") {
                  return <span>{categoryType && glossary[categoryType.toLowerCase()].trans}</span>;
                }
                if (domNode.attribs && domNode.attribs.id === "replace") {
                  return (
                    <span>
                      <Link to={ChangeServiceAuthorizationRoute} target="_blank">
                        {content.csAuthority}
                      </Link>
                    </span>
                  );
                }
              },
            })}
          </p>
        </div>
      </Row>
      {accountOwnerTypeField.input.value === "DIFFERENT_ACCOUNT_OWNER" && <Contact typeOfContact="accountHolder" />} 
      {isCompany && <CompanyCheckbox content={content} inheritedStyles={inheritedStyles} />}
      <AccountHolderAddressChanges />
    </>
  );
};

export default AccountOwner;
